<template>
  <div class="home">
    <HomeHeader />

    <div class="content">
      <div class="desc">
        <div v-if="content[language]" v-html="content[language].text.thisyear" />
      </div>
    </div>

    <div class="routelist-container">
      <RouteList :routen="BPRoutesComputed" />
    </div>


    <div class="fullwidth white">
      <div class="content ">
        <div class="desc">
          <div v-if="content[language]" v-html="content[language].subtext.thisyear" />
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import HomeHeader from '../components/HomeHeader.vue'
import RouteList from '../components/RouteList.vue'

export default {
  name: 'HomeView',

  components: {
    HomeHeader, RouteList,
  },

  data: function () {
    return {
      thisyear: 1,
    }
  },
  computed: {
    BPRoutesComputed: function () {
      return this.$root.BPRoutes
    },
    language: function () {
      return this.$root.$i18n.locale
    },
    content: function () {
      return this.$root.content
    },
  },

  methods: {
    firstPart(thestring) {
      if(!thestring) return
      return thestring.split('|')[0]
    },
    lastPart(thestring) {
      if(!thestring) return
      return thestring.split('|')[1]
    },
  },
}

</script>



<style scoped lang="scss">
  .home {
    background-color: #d3c6ac;

    .fullwidth {
      max-width: 100%;

      &.white {
        background-color: white;
      }
    }

    .content {
      max-width: 1024px;
      margin: 0 auto;
      padding: 40px 80px;
      box-sizing: border-box;
      text-align: center;

      @media screen and (max-width: 768px) {
        padding: 20px 30px;
      }

      .desc {
        text-align: left;
        z-index: 99;
        position: relative;

        @media screen and (max-width: 480px) {
          margin-top: 30px;

        }

      }

    }
  }
</style>

